// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../../styles/colours';

const Edge = ({ geometry, isHighlight }) => (
  <line geometry={geometry}>
    <lineBasicMaterial
      attach="material"
      color={isHighlight ? Colours.Yellow : Colours.Blue}
      linewidth={1}
      linecap="round"
      linejoin="round"
    />
  </line>
);

Edge.propTypes = {
  isHighlight: PropTypes.bool,
  geometry:    PropTypes.shape(Object),
};

Edge.defaultProps = {
  isHighlight: false,
  geometry:    {},
};

export default Edge;
